import React, {useContext, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import "./StartupProjects.scss";
import {bigProjects} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function StartupProject() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  function openProjectDetail(project) {
    setSelectedProject(project);
    setActiveImageIndex(0);
  }

  function closeProjectDetail() {
    setSelectedProject(null);
    setActiveImageIndex(0);
  }

  const galleryImages =
    selectedProject && selectedProject.detailImages?.length > 0
      ? selectedProject.detailImages
      : selectedProject?.image
      ? [selectedProject.image]
      : [];

  useEffect(() => {
    const handleEsc = event => {
      if (event.key === "Escape") {
        closeProjectDetail();
      }
    };

    if (selectedProject) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [selectedProject]);


  const {isDark} = useContext(StyleContext);
  if (!bigProjects.display) {
    return null;
  }
  const content = (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {bigProjects.subtitle}
          </p>

          <div className="projects-container">
            {bigProjects.projects.map((project, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                  role="button"
                  tabIndex={0}
                  onClick={() => openProjectDetail(project)}
                  onKeyDown={event => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      openProjectDetail(project);
                    }
                  }}
                >
                  {project.image ? (
                    <div className="project-image">
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="card-image "
                      ></img>
                    </div>
                  ) : null}
                  <div className="project-detail">
                    <h5
                      className={isDark ? "dark-mode card-title" : "card-title"}
                    >
                      {project.projectName}
                    </h5>
                    <p
                      className={
                        isDark ? "dark-mode card-subtitle" : "card-subtitle"
                      }
                    >
                      {project.projectDesc}
                    </p>
                    <span className="project-click-hint">Klik untuk lihat detail</span>
                    {project.footerLink ? (
                      <div className="project-card-footer">
                        {project.footerLink.map((link, i) => {
                          return (
                            <span
                              key={i}
                              className={
                                isDark ? "dark-mode project-tag" : "project-tag"
                              }
                              onClick={event => {
                                event.stopPropagation();
                                openUrlInNewTab(link.url);
                              }}
                            >
                              {link.name}
                            </span>
                          );
                        })}
                      </div>
                    ) : null}
                    <button
                      type="button"
                      className="project-detail-button"
                      onClick={event => {
                        event.stopPropagation();
                        openProjectDetail(project);
                      }}
                    >
                      Lihat Detail
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );

  return (
    <>
      {content}
      {selectedProject
        ? ReactDOM.createPortal(
            <div className="project-detail-modal" onClick={closeProjectDetail}>
              <div
                className={
                  isDark
                    ? "dark-mode project-detail-modal-content"
                    : "project-detail-modal-content"
                }
                onClick={event => event.stopPropagation()}
              >
                <button
                  type="button"
                  className="project-detail-close"
                  onClick={closeProjectDetail}
                  aria-label="Close detail"
                  title="Tutup"
                >
                  x
                </button>

                <h3 className={isDark ? "dark-mode card-title" : "card-title"}>
                  {selectedProject.projectName}
                </h3>
                <p className={isDark ? "dark-mode card-subtitle" : "card-subtitle"}>
                  {selectedProject.projectDesc}
                </p>

                {galleryImages.length > 0 ? (
                  <div className="project-gallery-wrapper">
                    <img
                      src={galleryImages[activeImageIndex]}
                      alt={`${selectedProject.projectName} preview ${activeImageIndex + 1}`}
                      className="project-gallery-main"
                    />
                    {galleryImages.length > 1 ? (
                      <div className="project-gallery-thumbs">
                        {galleryImages.map((image, imageIndex) => (
                          <button
                            key={`${selectedProject.projectName}-${imageIndex}`}
                            type="button"
                            className={
                              imageIndex === activeImageIndex
                                ? "project-gallery-thumb active"
                                : "project-gallery-thumb"
                            }
                            onClick={() => setActiveImageIndex(imageIndex)}
                          >
                            <img
                              src={image}
                              alt={`${selectedProject.projectName} thumb ${imageIndex + 1}`}
                            />
                          </button>
                        ))}
                      </div>
                    ) : null}
                  </div>
                ) : null}

                <div className="project-detail-actions">
                  <button
                    type="button"
                    className="project-detail-close-button"
                    onClick={closeProjectDetail}
                  >
                    Tutup
                  </button>
                </div>
              </div>
            </div>,
            document.body
          )
        : null}
    </>
  );
}
